export const rates = [
  { rate: "1.0x", rateName: "Normal" },
  { rate: "2.0x", rateName: "Medium" },
  { rate: "4.0x", rateName: "Fast" },
  { rate: "8.0x", rateName: "Very Fast" },
  { rate: "10.0x", rateName: "Super Fast" },
];
